import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';


@Component({
  selector: 'pt-checkbox-renderer',
  template: `
    <input
      style="width: 100%; text-align: center;"
      type="checkbox"
      (click)="checkedHandler($event)"
      [checked]="params.value"
    />
  `,
})
export class CheckboxRendererComponent implements ICellRendererAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  checkedHandler(event) {
    const checked = event.target.checked;
    const colId = this.params.column.colId;
    this.params.node.setDataValue(colId, checked);
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }
}
